import React from "react";

const Hero = () => {
  const stats = [
    { icon: "fa-chart-line", value: "78%", label: "Efficiency Gain" },
    { icon: "fa-clock", value: "65%", label: "Faster Approvals" },
    { icon: "fa-cogs", value: "100+", label: "Automations" },
    { icon: "fa-users", value: "50+", label: "Happy Clients" },
  ];

  return (
    <section
      id="home"
      className="hero-pattern"
      style={{
        minHeight: "100vh",
        display: "flex",
        alignItems: "center",
        background: "linear-gradient(to bottom right, white, #f9fafb, white)",
        paddingTop: "80px",
      }}
    >
      <div className="container" style={{ padding: "80px 16px" }}>
        <div
          className="hero-grid"
          style={{
            display: "grid",
            gridTemplateColumns: "1fr",
            gap: "48px",
            alignItems: "center",
          }}
        >
          <div
            style={{ display: "flex", flexDirection: "column", gap: "32px" }}
          >
            <div
              style={{
                display: "inline-flex",
                alignItems: "center",
                gap: "8px",
                backgroundColor: "rgba(23, 70, 162, 0.1)",
                color: "#1746A2",
                padding: "8px 16px",
                borderRadius: "9999px",
                fontSize: "14px",
                fontWeight: 500,
                width: "fit-content",
              }}
            >
              <i className="fas fa-rocket"></i>
              Transforming Businesses Digitally
            </div>

            <h1
              style={{
                fontSize: "clamp(2rem, 5vw, 3.5rem)",
                fontWeight: "bold",
                color: "#0C1A36",
                lineHeight: 1.2,
              }}
            >
              Digital Transformation. Intelligent Automation.{" "}
              <span className="gradient-text">Real Business Impact.</span>
            </h1>

            <p
              style={{
                fontSize: "1.25rem",
                color: "#4b5563",
                lineHeight: 1.8,
              }}
            >
              We design, build, and automate digital solutions that simplify
              operations, unlock efficiency, and accelerate organisational
              growth.
            </p>

            <div style={{ display: "flex", flexWrap: "wrap", gap: "16px" }}>
              <a href="#contact" className="btn-primary">
                <i className="fas fa-calendar-check"></i> Book a Consultation
              </a>
              <a href="#services" className="btn-outline">
                <i className="fas fa-compass"></i> Explore Our Services
              </a>
            </div>
          </div>

          <div className="floating hero-stats" style={{ position: "relative" }}>
            <div
              style={{
                position: "absolute",
                top: "-16px",
                left: "-16px",
                width: "288px",
                height: "288px",
                backgroundColor: "rgba(3, 11, 101, 0.2)",
                borderRadius: "50%",
                filter: "blur(60px)",
              }}
            ></div>
            <div
              style={{
                position: "absolute",
                bottom: "-16px",
                right: "-16px",
                width: "288px",
                height: "288px",
                backgroundColor: "rgba(12, 26, 54, 0.2)",
                borderRadius: "50%",
                filter: "blur(60px)",
              }}
            ></div>
            <div
              style={{
                position: "relative",
                backgroundColor: "white",
                borderRadius: "16px",
                boxShadow: "0 25px 50px rgba(0,0,0,0.15)",
                padding: "32px",
                border: "1px solid #f3f4f6",
              }}
            >
              <div
                style={{
                  display: "grid",
                  gridTemplateColumns: "repeat(2, 1fr)",
                  gap: "16px",
                }}
              >
                {stats.map((stat, index) => (
                  <div
                    key={index}
                    style={{
                      backgroundColor: "#f9fafb",
                      borderRadius: "12px",
                      padding: "24px",
                      textAlign: "center",
                    }}
                  >
                    <i
                      className={`fas ${stat.icon}`}
                      style={{
                        fontSize: "32px",
                        color: "#1746A2",
                        marginBottom: "12px",
                        display: "block",
                      }}
                    ></i>
                    <p
                      style={{
                        fontSize: "28px",
                        fontWeight: "bold",
                        color: "#0C1A36",
                      }}
                    >
                      {stat.value}
                    </p>
                    <p
                      style={{
                        fontSize: "14px",
                        color: "#6b7280",
                      }}
                    >
                      {stat.label}
                    </p>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>

      <style>{`
                @media (min-width: 1024px) {
                    .hero-grid { grid-template-columns: 1fr 1fr !important; }
                }
                @media (max-width: 1023px) {
                    .hero-stats { display: none; }
                }
            `}</style>
    </section>
  );
};

export default Hero;
